// extracted by mini-css-extract-plugin
export default {"light":"SkillOrder_light__uevr-","dark":"SkillOrder_dark__VnAdq","active":"SkillOrder_active__moS2e"};